<script context="module" lang="ts">
    // Shared between all instances = only one 'current' = the playing one
    let current: HTMLAudioElement
</script>

<script lang="ts">
    import {ASSETS_HOST} from '../../../../../consts';
    import SvgIcon from '$lib/components/assets/SvgIcon.svelte';
    import type {SentenceId} from '$lib/classes/data/_primitives';

    export let sentenceId: SentenceId

    const src = `${ASSETS_HOST}/audio/sentences/${sentenceId}.mp3`

    let audio = new Audio(src)

    let isPlaying = false
    audio.addEventListener('playing', () => {
        isPlaying = true
    })
    audio.addEventListener('pause', () => {
        isPlaying = false
    })
    audio.addEventListener('ended', () => {
        isPlaying = false
    })

    async function handleClick() {
        if (current) {
            current.pause()
            current.currentTime = 0
        }
        try {
            current = audio
            await current.play()
        } catch (error) {
            console.error('ERROR playing audio', error)
        }
    }

    // MERKE !!! auf audio.play() promise warten, bevor das alte gestoppt wird !!!
    // .load() hat auch geknackt >> audio.pause() + audio.currentTime = 0, audio.play() stattdessen !!!

</script>

<button on:click|stopPropagation={handleClick}
        class="play-audio-btn"
        class:is-playing={isPlaying}
>
    <SvgIcon name="audio" viewBox="-1 -1 32 32" height="100%"/>
</button>

<style>
    button {
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(calc(100% + .4rem), 0);
        width: 2rem;
        height: 2rem;
        margin: 0;
        padding: .25rem;
        background: none;
        color: var(--color-accent);
        justify-content: center;
        align-items: center;
    }

    button.is-playing {
        background: var(--color-accent);
        color: var(--text-on-color);
    }

    button:hover {
        box-shadow: 0 0 0 2px var(--color-accent) inset;
    }

    @media (max-width: 1000px) {
        button {
            width: 30px;
            height: 30px;
            transform: translate(calc(100% + 5px), 4px);
            color: var(--color-audio-browse-sentence-mobile);
        }

        button:hover {
            box-shadow: 0 0 0 2px var(--color-audio-browse-sentence-mobile) inset;
        }

        button.is-playing {
            box-shadow: none;
        }
    }
</style>